import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ArchitectureConstructionSignature from "./sections/ArchitectureConstructionSignature";
import OurSolutionLines from "./sections/OurSolutionLines";
import WarumWartmann from "./sections/WarumWartmann";
import RealTimeMarketPulse from "./sections/RealTimeMarketPulse";
import GlosGosci from "./sections/GlosGosci";
import ExpertCommentaryFaq from "./sections/ExpertCommentaryFaq";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ArchitectureConstructionSignature />
      <OurSolutionLines />
      <WarumWartmann />
      <RealTimeMarketPulse />
      <GlosGosci />
      <ExpertCommentaryFaq />
      <FooterInformation />
    </div>;
}